export default "__VITE_ASSET__BjwK8oVB__"